package ai.flowstorm.studio.resources.space

import ai.flowstorm.common.resources.EntityResource
import ai.flowstorm.studio.model.Style

object StyleResource: EntityResource<Style>(serializer = Style.serializer()) {

    fun loadPredefinedStyles() = listOf(
        Style(name = "Default"),
        Style(name = "Concern"),
        Style(name = "Joy"),
    )
}